__turbopack_context__.v({
  "checkoutBoxSection": "H1CJda_checkoutBoxSection",
  "sheetContentForIframe": "H1CJda_sheetContentForIframe",
  "timerMessage": "H1CJda_timerMessage",
  "triggerButton": "H1CJda_triggerButton",
});
